import {AuctionVehicleDetailResponseBody} from '../types';

export const getAuctionId = (item: AuctionVehicleDetailResponseBody) =>
  item.auctionVehicle.pk ?? item.auctionVehicle.adId ?? item.auctionVehicle.auctionId;

export const filterOutAuctionDuplicates = (
  currentCache: AuctionVehicleDetailResponseBody[],
  newData: AuctionVehicleDetailResponseBody[]
) => {
  const seenIds = new Set(currentCache.map(getAuctionId));
  return newData.filter((item) => {
    const id = getAuctionId(item);
    if (seenIds.has(id)) {
      return false;
    }
    seenIds.add(id);
    return true;
  });
};
